import economyApi from '../economy.service'

const loanApi = economyApi.injectEndpoints({
  endpoints: (builder) => ({
    getPendingInterestRateChanges: builder.query<boolean | null, string>({
      keepUnusedDataFor: 30,
      query: (clientId) => ({
        url: `/loan/${clientId}/loans/pendinginterestratechanges`,
        method: 'GET',

        // To avoid x-api-version: 1.0
        headers: {},
      }),
    }),
  }),
})

export const { useGetPendingInterestRateChangesQuery } = loanApi
export default loanApi
